import React from 'react';

import './style.scss';

export interface LinkTagProps {
  name: string;
  url: string;
}

const LinkTag = ({ name, url }: LinkTagProps) => (
  <a href={url} className="LinkTag">
    <span>
      {name}
    </span>
  </a>
);

export default LinkTag;
